const USER_ROLES = {
  ADMIN: 'ADMIN',
  MANAGER: 'MANAGER',
  SUPERVISOR: 'SUPERVISOR',
  USER: 'USER',
  OWNER: 'OWNER',
  RELATIVE: 'RELATIVE',
  MONITOR: 'MONITOR',
  BRANCH_MONITOR: "BRANCH_MONITOR",
  COMPANY_MONITOR: "COMPANY_MONITOR"
};

export default USER_ROLES;
